/* eslint-disable */
'use client';
declare var nbpix: any;
import { Cart } from '../../../interface/checkoutInterface';
import { RawEvent } from '../../../interface/eventInterface';
import { Tracker } from '../trackers';
export class NewsBreakTracker implements Tracker {
  private pixelIDs: string[];

  constructor(pixelIDs: string[]) {
    if (pixelIDs.length === 0) {
      throw new Error('NewsBreakTracker requires at least one pixel ID.');
    }
    this.pixelIDs = pixelIDs;
  }

  Init(): void {
    this.initializePixels();
  }

  private initializePixels() {
    (function (
      e: { [key: string]: any },
      n: Document,
      t: string,
      i: string,
      p?: any,
      a?: HTMLScriptElement,
      s?: Node,
    ) {
      if (!e[i]) {
        p = function () {
          if (typeof p.process === 'function') {
            p.process.apply(p, arguments);
          } else {
            p.queue.push(arguments);
          }
        };

        p.queue = [];
        p.t = +new Date();

        e[i] = p;

        a = n.createElement(t) as HTMLScriptElement;
        a.async = true;
        a.src =
          'https://static.newsbreak.com/business/tracking/nbpixel.js?t=' +
          864e5 * Math.ceil(new Date().getTime() / 864e5);
        a.onload = function () {};
        a.onerror = function () {
          console.error('Failed to load NB Pixel script');
        };

        s = n.getElementsByTagName(t)[0];
        s.parentNode!.insertBefore(a, s);
      }
    })(window as any, document, 'script', 'nbpix');
    this.pixelIDs.forEach(pixelID => {
      nbpix('init', pixelID);
      nbpix('event', 'pageload');
    });
  }

  TrackEvent(event: RawEvent): void {
    const mappedEventName = this.mapEventName(event.eventName);
    const cart: Cart | undefined = event?.cart;
    const eventData = {
      nb_value: cart ? parseFloat(cart.TotalAmount) || 0 : 0,
    };
    this.pixelIDs.forEach(pixelID => {
      try {
        nbpix('init', pixelID);
        nbpix('event', mappedEventName, eventData);
      } catch (error) {
        console.error(
          `Failed to track event: ${mappedEventName} for pixel ID: ${pixelID}`,
          error,
        );
      }
    });
  }

  private mapEventName(eventName: string): string {
    switch (eventName) {
      case 'InitiateCheckout':
        return 'initiate_checkout';
      case 'Purchase':
        return 'complete_payment';
      default:
        return eventName;
    }
  }
}
